import React from 'react';
import Row from '../../Row';
import Col from '../../Col';
import FontAwesomeIcon from '../../Icon';
import ChatExtraInfo from '../ChatExtraInfo/ChatExtraInfo';
import './user-chat-header.scss';

const UserChatHeader = ({
  title,
  referenceType,
  description,
  profileIcon,
  address,
  from,
  extraInfo,
  onNavigate,
}) => {
  return (
    <div className="user-chat-header">
      <Row>
        <Col md={6} xs={12}>
          <div className="chat-user">
            {from ? (
              <div className="chat-user-avatar">
                {' '}
                <img
                  src={profileIcon ? profileIcon : '/assets/avatar.svg'}
                  alt=""
                />{' '}
              </div>
            ) : (
              <div className="chat-user-icon">
                <FontAwesomeIcon
                  glyph={profileIcon}
                  weight="light"
                  size="custom"
                />
              </div>
            )}
            <div className="chat-user-info">
              <div
                className={onNavigate ? 'name clickable' : 'name'}
                onClick={onNavigate}
              >
                {title}
              </div>
              {description && (
                <div className="description">{description}</div>
              )}
            </div>
          </div>
        </Col>
        {address && (
          <Col md={6} xs={12}>
            <div className="chat-address">
              {' '}
              <FontAwesomeIcon
                glyph="map-marker"
                weight="light"
                size="medium"
              />
              {address}
            </div>
          </Col>
        )}
      </Row>

      {referenceType === 'Ticket' && <ChatExtraInfo extraInfo={extraInfo} />}

      <hr className="heading-divider" />
    </div>
  );
};
export default UserChatHeader;